/*** IMPORTS FROM imports-loader ***/
(function() {

define([
    'jquery',
    'mustache',
    'pip-model',
    'pip-events',
    'pip-common.validate',
    'pip-service.appliance-availability',
],
function(
    $,
    Mustache,
    pip,
    pipEvents,
    pipValidate,
    pipServiceApplianceAvailability
){

	var view = {
        selectors: {
            fbrContainer: '#fbr-container',
            fbrMobileContainer: '#fbr-mobile-container',
        	zipCodeText: '.zip-code__text',
        	zipCodeTextFormInput: '.zip-code__text .form-input__field',
        	zipCodeAvailability: '.zip-code-availability',
        	zipCodeAvailabilityDynamicBtn: '.zip-code-availability .dynamic_btn',
        	fbrCheckAvailability: '.fbr-check-availability',
        	changeLink: '.change-link',
        	fbrAnchorLink: '.fbrAnchorLink',
        	earliestDeliveryZipLabel: '#fbr-container .earliestDeliveryZipLabel',
        	changeZip: '.change-zip',
        	checkAvailabilityTd: '.check-availability-td',
        	zipCodeError: '.zip-code__error',
        	checkAvailabilityRowMobile: '.check-availability__row-mobile',
        	zipCodeInput: '.zip-code__input',
        	currentProduct: 'table.main-table > tbody > tr:first-child td.current',
        	mainTableTr: 'table.main-table > tbody > tr',
          currentAvailability: 'table tr.check-availability__row td.current',
          fbrMobileTable: '#fbr-mobile-container table.main-table',
          fbrMobileCurrentColumn: '#fbr-mobile-container table.main-table tr td.current'
        },
        classes: {
        	current: 'current',
        	checkAvailabilityTd: 'check-availability-td',
        	formInputError: 'form-input--error'
        },
        templates: {
            backordered : '<div class="critical-msg c">On Backorder Until: {{backorderedData}}</div>',
            oos: '<div class="error-msg c">Out of Stock</div>',
            unavailable: '<div class="error-msg c">Sorry, we do not offer appliance delivery to your ZIP code. Please check your local store for other arrangements.</div>',
            nomatchzip: '<div class="error-msg c">All major appliances must be delivered to the same address. Please click Change above to enter the original ZIP Code.</div>',
            serviceException: '<div class="critical-msg c">You may select your delivery date during checkout.</div>',
            ajaxLoader: '<div class="c"><img width="25" height="25" alt="" src="https://assets.homedepot-static.com/p/static/images/ajax-loader-orange.gif"></div>',
            discontinued: '<div class="error-msg c">Discontinued</div>',
            earliestDeliveryLabel: 'Earliest Delivery to {{zipcode}}'
        },
        render: {
        	backordered: function renderBackordered(backorderedData) {
	    		return Mustache.render(view.templates.backordered, {backorderedData: backorderedData});
	        },
            deliveryZipLabel: function renderDeliveryZipLabel() {
                return Mustache.render(view.templates.earliestDeliveryLabel, {zipcode: viewModel.zipcode});
            }
        },
        updateDOM: {
            fbrContainer: function updateFbrContainer() {
                $(view.selectors.fbrContainer).html(model.fbrData);
                $(view.selectors.fbrContainer).append("<div id='searchFeedback'> </div>");
            },
            fbrMobileContainer: function updateFbrContainer() {
                $(view.selectors.fbrMobileContainer).html(model.fbrData);
            },
            earliestdelivery: function updateEarliestdelivery() {
            	$(view.selectors.earliestDeliveryZipLabel).html(view.render.deliveryZipLabel());
            },
            hideFbrContainer: function hideFbrContainer () {
                $(view.selectors.fbrContainer).remove();
            },
            hideFbrMobileContainer: function hideFbrContainer () {
                $(view.selectors.fbrMobileContainer).remove();
            },

            addLeafNodeToTitle: function addLeafNodeToTitle() {
                var title = $(view.selectors.fbrContainer).find('h2').text();
                var leafNode = pip.products.primary.data.itemExtension.categoryName;
                $(view.selectors.fbrContainer).find('h2').text(title + leafNode);
            },

            highlightCurrentProduct: function highlightCurrentProduct() {
                var current = $(view.selectors.fbrContainer).find(view.selectors.currentProduct).index();
                if (current > -1) {
                    $(view.selectors.fbrContainer).find(view.selectors.mainTableTr).each(function() {
                        $(this).find('>td').eq(current).addClass(view.classes.current);
                    });
                }
            },

            setDiscontinuedMsgForCurrentProduct: function setDiscontinuedMsgForCurrentProduct() {
                if (pip.products.primary.data.itemAvailability.discontinuedItem) {
                    $(view.selectors.fbrContainer).find(view.selectors.currentAvailability).html(view.templates.discontinued).removeClass(view.classes.checkAvailabilityTd);
                }
            },

            overrideFbrZipCode: function overrideFbrZipCode(buyBeltZipCode) {
                $(view.selectors.fbrContainer).find(view.selectors.zipCodeTextFormInput).val(buyBeltZipCode);
            }
        },
        init: function initView() {
            view.initEventListeners();
            view.updateDOM.addLeafNodeToTitle();
            view.updateDOM.highlightCurrentProduct();
            view.updateDOM.setDiscontinuedMsgForCurrentProduct();
            if (pip.features.fbrMobileVersionFeatureEnabled && pip.platform.toLowerCase() === 'mobile') {
              view.switchColumns(view.selectors.fbrMobileTable, 0, $(view.selectors.fbrMobileCurrentColumn).index());
            }
        },

        initEventListeners: function initEventListeners() {
            pipEvents.appliance.applianceAvailabilityChecked.on(function(evtType, data) {
	            if(data && data.processedResponse && !data.processedResponse.isError){
                    view.updateDOM.overrideFbrZipCode(data.processedResponse.zipCode);
	                viewModel.checkAvailability(data.response, null, data.processedResponse.zipCode);
	            }
            });

            pipEvents.appliance.applianceAvailabilityCheckedV3.on(function(evtType, data) {
                if(data && data.processedResponse && !data.processedResponse.length > 0 && !data.processedResponse[0].isError){
                    view.updateDOM.overrideFbrZipCode(data.processedResponse[0].zipCode);
	                viewModel.checkAvailability(data.rawResponse, null, data.processedResponse[0].zipCode);
	            }
            });

            $(document).off(view.selectors.zipCodeAvailability).on('click.zip-code-availability', view.selectors.zipCodeAvailabilityDynamicBtn, function(e) {
                e.preventDefault();
                viewModel.checkAvailability({}, e);
            });

            $(document).off(view.selectors.fbrCheckAvailability).on('click.fbr-check-availability', view.selectors.fbrCheckAvailability, function(e) {
                e.preventDefault();
                $(view.selectors.fbrContainer).find(view.selectors.zipCodeAvailability).toggle();
            });

            $(document).off(view.selectors.changeLink).on('click.change-link', view.selectors.changeLink, function(e) {
                e.preventDefault();
                $(view.selectors.fbrContainer).find(view.selectors.zipCodeAvailability).show();
                $(view.selectors.fbrContainer).find(view.selectors.fbrCheckAvailability).show();
                $(view.selectors.fbrContainer).find(view.selectors.changeZip).hide();
            });

            $(document).off(view.selectors.fbrAnchorLink).on('click.fbrAnchorLink', view.selectors.fbrAnchorLink, function(e) {
                e.preventDefault();
                pipEvents.fbr.fbrLinkClicked.trigger({
                    displayPosition: $(this).closest('td').index(),
                    anchorProductSku: pip.products.primary.data.itemId,
                    recommendationVersion: $(this).closest('table').attr('data-recommendation-version'),
                    featureVersion: $(this).closest('table').attr('data-feature-version'),
                    href: $(this).attr('href')
                });
            });
        },

        switchColumns: function switchColumns (selector, nonActiveColumn, activeColumn) {
          if (activeColumn > 0) {
            var $this = $(selector);
            var $tableRows = $this.find('tr');

            $tableRows.each(function(i, element){
              var $element = $(element);
              var $tableData = $element.find('td');
              var $tempTableData;
              $tempTableData = $tableData.eq(activeColumn).clone();
              $tableData.eq(activeColumn).remove();

              $(this).find('td').eq(nonActiveColumn).before($tempTableData);
            });
          }
        }
    };

    var viewModel = {
        zipcode: '',
        resetZipCodeSection: function resetZipCodeSection(zipcode) {
        	view.updateDOM.earliestdelivery(zipcode);
            $(view.selectors.fbrContainer).find(view.selectors.changeZip).show();
            $(view.selectors.fbrContainer).find(view.selectors.checkAvailabilityRowMobile).hide();
            $(view.selectors.fbrContainer).find(view.selectors.zipCodeAvailability).hide();
            $(view.selectors.fbrContainer).find(view.selectors.fbrCheckAvailability).hide();
            $(view.selectors.fbrContainer).find(view.selectors.zipCodeError).hide();
            $(view.selectors.fbrContainer).find(view.selectors.zipCodeText).removeClass(view.classes.formInputError);
        },

        checkAvailability: function checkAvailability(responseData, element, zipcode) {
            viewModel.zipcode = zipcode;
            if (element) {
                viewModel.zipcode = $(element.currentTarget).closest(view.selectors.zipCodeInput).find(view.selectors.zipCodeTextFormInput).val()
            }
            if (pipValidate.validateZipCode(viewModel.zipcode)) {
                viewModel.resetZipCodeSection(viewModel.zipcode);
                $(view.selectors.checkAvailabilityTd).each(function () {
                    var currentTd = $(this);
                    currentTd.html(view.templates.ajaxLoader);
                    if(responseData && currentTd.hasClass(view.classes.current)) {
                        currentTd.html(viewModel.getAvailabilityTemplateV3(responseData));
                    } else {
                        pipServiceApplianceAvailability.getApplianceAvailability(currentTd.attr('data-itemid'), viewModel.zipcode).always(function (data) {
                            currentTd.html(viewModel.getAvailabilityTemplateV3(data));
                        });
                    }
                });
            } else {
                $(view.selectors.fbrContainer).find(view.selectors.zipCodeText).addClass(view.classes.formInputError);
                $(view.selectors.fbrContainer).find(view.selectors.zipCodeError).show();
            }
        },

        getAvailabilityTemplate: function getAvailabilityTemplate(data) {
            if(!data || !data.processedResponse || data.processedResponse.isError) { return view.templates.serviceException; }
            if(data.processedResponse.isAvailable) { return data.processedResponse.deliveryDate; }
            if(data.processedResponse.isBackOrdered) { return view.render.backordered(data.processedResponse.backOrderedEstimatedDeliveryDate); }
            if(data.processedResponse.isOutOfStock) { return view.templates.oos; }
            return view.templates.unavailable;
        },

        getAvailabilityTemplateV3: function getAvailabilityTemplateV3(data) {
            if(!data || !data.processedResponse || !data.processedResponse.length > 0 || data.processedResponse[0].isError) { return view.templates.serviceException; }
            if(data.processedResponse[0].isAvailable) { return data.processedResponse[0].deliveryDate; }
            if(data.processedResponse[0].isBackOrdered) { return view.render.backordered(data.processedResponse[0].backOrderedEstimatedDeliveryDate); }
            if(data.processedResponse[0].isOutOfStock) { return view.templates.oos; }
            return view.templates.unavailable;
        }

    };

    var model = {
    	fbrData: {},
        makeMerchandiseFbrCall: function makeMerchandiseFbrCall() {
            return $.ajax({
                url : '/p/svcs/fbr/' + pip.products.primary.data.itemId,
                dataType: "html",
                timeout : 10000,
                cache: false
            });
        },
        init: function initModel(data) {
        	model.fbrData = data;
        }
    };

	return {
		init: function() {
			if (pip.products.primary.data.info.recommendationFeatures && pip.products.primary.data.info.recommendationFeatures.indexOf('FBR') > -1) {
				if ($(view.selectors.fbrContainer).length || $(view.selectors.fbrMobileContainer).length) {
					if(pip.products.primary.data.info.isAppliance) {
            view.init();
					} else {
                        model.makeMerchandiseFbrCall().done(function(data) {
                            model.init(data);
                            if (pip.features.fbrMobileVersionFeatureEnabled && pip.platform.toLowerCase() === 'mobile') {
                                view.updateDOM.fbrMobileContainer();
                            } else {
                                view.updateDOM.fbrContainer();
                            }
                            view.init();
		                }).fail(function() {
                            if (pip.features.fbrMobileVersionFeatureEnabled && pip.platform.toLowerCase() === 'mobile') {
                                view.updateDOM.hideFbrMobileContainer();
                            } else {
                                view.updateDOM.hideFbrContainer();
                            }
		                });
					}
				}
			} else {
                view.updateDOM.hideFbrContainer();
            }
		},
		viewModel: viewModel,
		view: view,
		model: model
	};
});

}.call(window));